import { Injectable } from '@angular/core';
import { CameraService } from './camera.service';
import { EngineService } from './engine.service';
import { OrbitService } from './orbit.service';
import { AppSettingsService } from './app-settings.service';
import { ScreenshotPreprocessService } from './screenshot-preprocess.service';
import { SnapShotService } from './snap-shot.service';
import { Select3dService } from './select-3d.service';
import { MoveStairsService } from './move-stairs.service';
import { Subject } from 'rxjs/Subject';
import { DragFloorEdge } from './drag-floor-edge.service';
import { TierStepWidthService } from './tier-step-width.service';

@Injectable()
export class ViewSwitcherService {

  controls: any;
  public needViewModeIconUpdate = new Subject<boolean>();

  constructor(
    private cameraManager: CameraService,
    private engine: EngineService,
    private orbitControl: OrbitService,
    private appSetting: AppSettingsService,
    private screenshotPreprocess: ScreenshotPreprocessService,
    private snapShotSrvc: SnapShotService,
    private select3dService: Select3dService,
    private moveStairsService: MoveStairsService,
    private dragFloorEdge: DragFloorEdge,
    private tierStepWidthService: TierStepWidthService
  ) { }

  switchView(value: boolean) {
    this.appSetting.is2D = value;
    if (this.appSetting.is2D === false) {
      const screenshot = this.screenshotPreprocess.clipEmptySpace2D();
      this.snapShotSrvc.setProjectImg(screenshot);
    }
    if (this.select3dService.getSelectedStair() !== null && this.moveStairsService.selectedStair !== null) {
      this.moveStairsService.removeSprites();
      this.moveStairsService.drawSprites();
    } else if (this.select3dService.getSelectedStair() === null) {
      this.moveStairsService.removeSprites();
    }

    if (this.dragFloorEdge.isEnabled()) {
      this.dragFloorEdge.removeSprites();
    }
    if (this.tierStepWidthService.isEnabled()) {
      this.tierStepWidthService.removeSprites();
    }

    value ? this.to2D() : this.to3D();
  }

  private to3D() {
    this.cameraManager.switchTo3D();
    this.orbitControl.update();
    this.orbitControl.enable();
    this.engine.setActiveStepState();
  }

  private to2D() {

    this.orbitControl.disable();
    this.cameraManager.switchTo2D();

    const camera = this.cameraManager.camera;

    if (this.cameraManager.isIn2D()) {
      camera.layers.enable(1); // show connection points
      camera.layers.enable(6); // show floor area
    } else {
      camera.layers.disable(1); // hide connection points
      camera.layers.disable(6); // hide floor area
    }

    this.engine.setActiveStepState();
  }
}






// WEBPACK FOOTER //
// ./src/app/services/view-switcher.service.ts